import { HumanParam, SellerClassifieds } from '~/models/search/types'
import { KeyValue } from '~/models/common/types'

export function formatAdTargetingToKeyValue(adTargeting: any): KeyValue {
  return {
    key: adTargeting.name,
    value: adTargeting.value
  }
}
export function formatHumanParam(p: any): HumanParam {
  return {
    isUnselectable: p.is_unselectable,
    name: p.name,
    seoName: p.seo_name,
    urlArg: p.urlarg,
    value: p.value,
    selectedUrlArgValuePairs: p.selected_urlarg_value_pairs
  }
}

export function formatSellersClassifieds(c: any): SellerClassifieds {
  return {
    total: c.total,
    privateSellers: c.private_sellers && {
      count: c.private_sellers.count,
      seoUrl: c.private_sellers.seo_url
    }
  }
}
